import { getData } from "./rest-api-helper"

export async function getConsignorInv({ shipmtId }) {
    const details = {
        urlPath: `/pdf/consignorInv/${shipmtId}`
    }

    const res = await getData(details);
    // console.log(res, "---------------getConsignorInv");
    return res.fileUrl;
}

export async function getCustLRCopy({ custReqId }) {
    const details = {
        urlPath: `/pdf/custLRCopy/${custReqId}`
    }

    const res = await getData(details);
    // console.log(res, "---------------getCustLRCopy");
    return res.fileUrl;
}

export async function getDeliveryRecpt({ shipmtId }) {
    const details = {
        urlPath: `/pdf/deliveryRecpt/${shipmtId}`
    }

    const res = await getData(details);
    // console.log(res, "---------------getDeliveryRecpt");
    return res.fileUrl;
}

export async function getShipmtPdf({ shipmtId }) {
    const details = {
        urlPath: `/pdf/shipmtPdf/${shipmtId}`
    }

    const res = await getData(details);
    // console.log(res, "---------------getShipmtPdf");
    return res.fileUrl;
}

export async function getTrkFreightRecpt({ trkOpReqId }) {
    const details = {
        urlPath: `/pdf/trkFreight/${trkOpReqId}`
    }

    const res = await getData(details);
    // console.log(res, "---------------getTrkFreightRecpt");
    return res.fileUrl;
}

// Combined ZIP of all linked shipments' documents (Bills / E-Way Bills /
// LR Copies Manual+System / POD Copies). Can take a while for many shipments.
export async function getShipmtDocsZip({ trkOpReqId }) {
    const details = {
        urlPath: `/pdf/shipmtDocsZip/${trkOpReqId}`
    }
    const res = await getData(details);
    return res.fileUrl;
}

// Single-shipment document ZIP (shipment ID as root folder).
export async function getSingleShipmtDocsZip({ shipmtId }) {
    const details = {
        urlPath: `/pdf/shipmtDocsZip/single/${shipmtId}`
    }
    const res = await getData(details);
    return res.fileUrl;
}

export async function getShipmentSummaryPdf({ trkOpReqId }) {
    const details = {
        urlPath: `/pdf/shipment-summary/${trkOpReqId}`
    }
    const res = await getData(details);
     //console.log(res, "---------------getShipmentSummaryPdf");
    return res.fileUrl;
}